(() => {
  const gate = document.querySelector('[data-age-gate]');
  const content = document.querySelector('[data-age-gated-content]');

  if (!gate || !content) return;

  const acceptButton = gate.querySelector('[data-age-gate-accept]');
  const storageKey = gate.dataset.storageKey;
  const storageDays = Number(gate.dataset.storageDays) || 30;
  let lastFocusedElement = null;
  let activeStorage = null;

  try {
    activeStorage = window.localStorage;
  } catch {
    try {
      activeStorage = window.sessionStorage;
    } catch {
      activeStorage = null;
    }
  }

  const getStoredValue = () => {
    if (!activeStorage) return null;

    try {
      return activeStorage.getItem(storageKey);
    } catch {
      try {
        activeStorage = window.sessionStorage;
        return activeStorage.getItem(storageKey);
      } catch {
        activeStorage = null;
        return null;
      }
    }
  };

  const hasValidVerification = () => {
    const storedValue = getStoredValue();
    if (!storedValue) return false;

    try {
      const verification = JSON.parse(storedValue);
      const verifiedAt = Number(verification.verifiedAt);
      const expiresAt = verifiedAt + storageDays * 24 * 60 * 60 * 1000;

      if (!Number.isFinite(verifiedAt) || Date.now() >= expiresAt) {
        activeStorage.removeItem(storageKey);
        return false;
      }

      return true;
    } catch {
      return false;
    }
  };

  const rememberVerification = () => {
    const value = JSON.stringify({
      version: 1,
      verifiedAt: Date.now(),
      method: 'self-declaration',
    });

    if (!activeStorage) return;

    try {
      activeStorage.setItem(storageKey, value);
    } catch {
      try {
        activeStorage = window.sessionStorage;
        activeStorage.setItem(storageKey, value);
      } catch {
        activeStorage = null;
        // The current page can still be revealed if browser storage is unavailable.
      }
    }
  };

  const focusableElements = () =>
    [...gate.querySelectorAll('button:not([disabled]), a[href]')].filter(
      (element) => element.offsetParent !== null,
    );

  const setGateState = (isOpen) => {
    gate.hidden = !isOpen;
    gate.setAttribute('aria-hidden', String(!isOpen));
    content.toggleAttribute('inert', isOpen);

    if (isOpen) {
      content.setAttribute('aria-hidden', 'true');
      document.body.classList.add('age-gate-active');
      window.requestAnimationFrame(() => acceptButton?.focus({ preventScroll: true }));
    } else {
      content.removeAttribute('aria-hidden');
      document.body.classList.remove('age-gate-active');
    }
  };

  const handleKeydown = (event) => {
    if (gate.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = focusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const keepFocusInside = (event) => {
    if (!gate.hidden && !gate.contains(event.target)) {
      acceptButton?.focus({ preventScroll: true });
    }
  };

  const accept = () => {
    lastFocusedElement = document.activeElement;
    rememberVerification();
    setGateState(false);

    const main = document.querySelector('#MainContent');
    if (main) {
      main.focus({ preventScroll: true });
    } else {
      lastFocusedElement?.focus?.({ preventScroll: true });
    }
  };

  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('focusin', keepFocusInside);
  acceptButton?.addEventListener('click', accept);

  if (hasValidVerification()) {
    setGateState(false);
  } else {
    setGateState(true);
  }
})();